import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useReviewStats(data = {}) {
  const { enabled = false, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getData() {
    return privateFetch.get(`/v1/admin/review_stats`, configs).then((res) => res.data);
  }

  return useQuery('user-review-stats', getData, { enabled });
}

export default useReviewStats;
